import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isFixedSize", "hasDataRow", "children"];

/* eslint-disable @repo/internal/react/require-jsdoc */

/** @jsx jsx */
import { forwardRef } from 'react';
import { css, jsx } from '@emotion/react';
import { gridSize as getGridSize } from '@atlaskit/theme/constants';
import { row, tableBorder } from '../theme';
var gridSize = getGridSize();
// CSS vars for table row
// these are declared here to avoid being re-declared in each table row
export var tableRowCSSVars = {
  CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
  CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
  CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
  CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
};
var fixedSizeTableStyles = css({
  tableLayout: 'fixed'
});
var tableStyles = css({
  width: '100%',
  borderCollapse: 'separate',
  borderSpacing: '0px'
});
var bodyBorder = css({
  borderBottom: "2px solid ".concat(tableBorder.borderColor)
});
export var Table = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref2;

  var isFixedSize = _ref.isFixedSize,
      hasDataRow = _ref.hasDataRow,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return jsx("table", _extends({
    style: (_ref2 = {}, _defineProperty(_ref2, tableRowCSSVars.CSS_VAR_HOVER_BACKGROUND, row.hoverBackground), _defineProperty(_ref2, tableRowCSSVars.CSS_VAR_HIGHLIGHTED_BACKGROUND, row.highlightedBackground), _defineProperty(_ref2, tableRowCSSVars.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND, row.hoverHighlightedBackground), _defineProperty(_ref2, tableRowCSSVars.CSS_VAR_ROW_FOCUS_OUTLINE, row.focusOutline), _ref2),
    css: [tableStyles, isFixedSize && fixedSizeTableStyles, hasDataRow && bodyBorder],
    ref: ref
  }, rest), children);
});
var captionStyles = css({
  marginTop: "".concat(gridSize * 3.5, "px"),
  marginBottom: "".concat(gridSize, "px"),
  fontSize: '1.42857143em',
  fontStyle: 'inherit',
  fontWeight: 500,
  letterSpacing: '-0.008em',
  lineHeight: 1.2,
  textAlign: 'left',

  /* there is a bug in Safari: if element which creates a new stacking context
    is a child of a table, table caption re-renders in bad wrong position
    https://stackoverflow.com/questions/44009186/safari-bug-translating-table-row-group-using-gsap-make-caption-jump-to-bottom
  */
  willChange: 'transform'
});
export var Caption = function Caption(_ref3) {
  var children = _ref3.children;
  return jsx("caption", {
    css: captionStyles
  }, children);
};
var paginationWrapperStyles = css({
  display: 'flex',
  justifyContent: 'center'
});
export var PaginationWrapper = function PaginationWrapper(_ref4) {
  var children = _ref4.children;
  return jsx("div", {
    css: paginationWrapperStyles
  }, children);
};